/** @jsx jsx */
import { CardHorizontalDivider, CardHorizontalDividerSize, Flex, FlexGap, HeadingSize } from "@eworkit/iris";
import React, { FC } from "react";
import { jsx } from "theme-ui";

import { TimeReport } from "@/data/time-reports";

import { TimeReportSummaryProject } from "./TimeReportSummaryProject";

interface TimeReportSummaryProjectsProps {
  timeReport: TimeReport;
  headingSize?: HeadingSize;
  dividerSize?: CardHorizontalDividerSize;
  gap?: FlexGap;
}

export const TimeReportSummaryProjects: FC<TimeReportSummaryProjectsProps> = ({
  timeReport,
  headingSize,
  dividerSize = "wide",
  gap = "sm",
}) => {
  const allProjectsSummary = timeReport.summary.find(p => !p.project);
  const projects = timeReport.summary.filter(p => p.project);

  return (
    <Flex flexDirection="column" gap={gap}>
      {allProjectsSummary && (
        <TimeReportSummaryProject timeReport={timeReport} project={allProjectsSummary} headingSize={headingSize} />
      )}

      {projects.map(project => (
        <React.Fragment key={project.project!.project.guid}>
          <CardHorizontalDivider sx={{ my: 0 }} size={dividerSize} />
          <TimeReportSummaryProject timeReport={timeReport} project={project} collapsible headingSize={headingSize} />
        </React.Fragment>
      ))}
    </Flex>
  );
};
